import React, { useEffect, useState } from 'react'
import {SearchIcon} from "@heroicons/react/outline";
import { useRecoilState } from 'recoil';
import { usersSearch } from '../../recoil/users';

const UserSearch = () => {
  const [searchUser, setSearchUser] = useRecoilState(usersSearch);
  const [search, setSearch] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    setSearchUser(search);
  }

  useEffect(() => {
    setSearch(searchUser);
  }, [searchUser]);

  return (
    <form onSubmit={handleSearch} className="flex items-center flex-1 px-5 py-3 rounded-lg bg-slate-50">
        <input type="search" onChange={e => setSearch(e.target.value)} value={search} className="w-full p-0 bg-transparent border-none focus:ring-0" placeholder="Cari Pengguna" />
        <button type="submit">
            <SearchIcon className="w-6 h-6" />
        </button>
    </form>
  )
}

export default UserSearch